import Vue from 'vue'
import App from './App.vue'
import Unicon from 'vue-unicons/dist/vue-unicons-vue2.umd'
import { uniFileAlt, uniFileBlank, uniFileCheck, uniFileCheckAlt, uniFileExclamation, uniFolder, uniFolderCheck, uniFolderDownload, uniFolderExclamation, uniFolderMedical, uniFolderTimes, uniFolderOpen, uniFolderPlus, uniCheck, uniSave, uniEnvelopeUpload, uniUser, uniUserCheck, uniUserPlus, uniSitemap, uniUserSquare, uniPlaneDeparture, uniSearch, uniTrashAlt, uniAngleDown, uniAngleLeft, uniAngleRight, uniAngleUp, uniStarSolid, uniFavorite, uniFileDownloadAlt, uniTable } from 'vue-unicons/dist/icons'
import './registerServiceWorker'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Unicon.add([uniFileAlt, uniFileBlank, uniFileCheck, uniFileCheckAlt, uniFileExclamation, uniFolder, uniFolderCheck, uniFolderDownload, uniFolderExclamation, uniFolderMedical, uniFolderTimes, uniFolderOpen, uniFolderPlus, uniCheck, uniSave, uniEnvelopeUpload, uniUser, uniUserCheck, uniUserPlus, uniSitemap, uniUserSquare, uniPlaneDeparture, uniSearch, uniTrashAlt, uniAngleDown, uniAngleLeft, uniAngleRight, uniAngleUp, uniStarSolid, uniFavorite, uniFileDownloadAlt, uniTable])
Vue.use(Unicon)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
